


// import { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { Layers, Mail, User, Building2, Shield, Eye, EyeOff, Briefcase } from "lucide-react";

// export default function Login() {
//     const navigate = useNavigate();
//     const [rememberMe, setRememberMe] = useState(false);
//     const [selectedRole, setSelectedRole] = useState("user");
//     const [showPassword, setShowPassword] = useState(false);

//     const roles = [
//         { id: "user", label: "User", icon: User },
//         { id: "expert", label: "Expert", icon: Briefcase },
//         { id: "vendor", label: "Vendor", icon: Building2 },
//         {id:"admin", label:"Admin",icon:Shield},
//         // { id: "admin", label: "Admin", icon: Shield },
//     ];

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (selectedRole === "user") {
//             navigate("/app/dashboard");
//             return;
//         }

//         if (selectedRole === "expert") {
//             navigate("/app/expert-dashboard"); // or wherever you want experts to go
//             return;
//         }
//         if (selectedRole === "admin") {
//             navigate("/admin"); // or wherever you want experts to go
//             return;
//         }

//         // Vendor / Admin dashboards aren't built yet
//     };

//     return (
//         <div className="min-h-screen grid lg:grid-cols-2">
//             {/* Left panel */}
//             <div className="hidden lg:flex flex-col justify-between bg-gradient-to-br from-[#1e1b4b] via-[#4338ca] to-[#7c3aed] text-white p-12">
//                 <Link to="/" className="flex items-center gap-3">
//                     <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center">
//                         <Layers className="text-white w-5 h-5" />
//                     </div>
//                     <div>
//                         <p className="font-bold leading-tight">
//                             APIC <span className="text-indigo-200">ProtoHub</span>
//                         </p>
//                         <p className="text-[11px] tracking-wide text-indigo-200 leading-tight">
//                             ANDHRA PRADESH
//                         </p>
//                     </div>
//                 </Link>

//                 <div>
//                     <h1 className="text-4xl font-extrabold leading-tight mb-4">
//                         Discover. Design. <br /> Prototype. Innovate.
//                     </h1>
//                     <p className="text-indigo-100 max-w-sm">
//                         A unified digital operating system for Andhra Pradesh's
//                         Advanced Prototyping & Innovation Centres.
//                     </p>
//                 </div>

//                 <p className="text-sm text-indigo-200">
//                     © 2026 APIC ProtoHub · Government of Andhra Pradesh
//                 </p>
//             </div>

//             {/* Right panel */}
//             <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
//                 <div className="rounded-xl border bg-card text-card-foreground shadow p-8 w-full max-w-md">
//                     <h2 className="text-2xl font-extrabold text-gray-900 mb-1">
//                         Welcome back
//                     </h2>
//                     <p className="text-gray-600 mb-8">
//                         Sign in to your ProtoHub workspace.
//                     </p>

//                     {/* Role Selector - Subtle Toggle */}
//                     <div className="bg-gray-50/80 rounded-xl p-1.5 mb-8 border border-gray-100/80 flex gap-1">
//                         {roles.map((role) => {
//                             const Icon = role.icon;
//                             const isActive = selectedRole === role.id;
//                             return (
//                                 <button
//                                     key={role.id}
//                                     type="button"
//                                     onClick={() => setSelectedRole(role.id)}
//                                     className={`
//                                         flex-1 flex items-center justify-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
//                                         ${isActive
//                                             ? "bg-white shadow-sm text-indigo-700 ring-1 ring-indigo-100"
//                                             : "text-gray-500 hover:text-gray-700 hover:bg-white/50"
//                                         }
//                                     `}
//                                 >
//                                     <Icon className={`w-4 h-4 ${isActive ? "text-indigo-600" : "text-gray-400"}`} />
//                                     {role.label}
//                                 </button>
//                             );
//                         })}
//                     </div>

//                     <form className="space-y-5" onSubmit={handleSubmit}>
//                         <label className="block">
//                             <span className="block text-sm font-medium text-gray-700 mb-1.5">Email</span>
//                             <input
//                                 type="email"
//                                 placeholder="innovator@apic.ap.gov.in"
//                                 className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
//                             />
//                         </label>

//                         <label className="block">
//                             <span className="block text-sm font-medium text-gray-700 mb-1.5">Password</span>
//                             <div className="relative">
//                                 <input
//                                     type={showPassword ? "text" : "password"}
//                                     placeholder="••••••••"
//                                     className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent pr-12"
//                                 />
//                                 <button
//                                     type="button"
//                                     onClick={() => setShowPassword(!showPassword)}
//                                     className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
//                                 >
//                                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                                 </button>
//                             </div>
//                         </label>

//                         <div className="flex items-center justify-between text-sm">
//                             <label className="flex items-center gap-2 text-gray-600">
//                                 <input
//                                     type="checkbox"
//                                     checked={rememberMe}
//                                     onChange={(e) => setRememberMe(e.target.checked)}
//                                     className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
//                                 />
//                                 Remember me
//                             </label>
//                             <a href="#forgot" className="text-indigo-600 font-medium hover:underline">
//                                 Forgot password?
//                             </a>
//                         </div>

//                         <button
//                             type="submit"
//                             className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-600 hover:opacity-90 text-white font-semibold py-3 rounded-xl transition"
//                         >
//                             Sign in as {selectedRole.charAt(0).toUpperCase() + selectedRole.slice(1)} →
//                         </button>
//                     </form>

//                     <div className="flex items-center gap-4 my-6">
//                         <div className="flex-1 h-px bg-gray-200" />
//                         <span className="text-xs text-gray-400 font-medium">OR</span>
//                         <div className="flex-1 h-px bg-gray-200" />
//                     </div>

//                     <p className="text-center text-sm text-gray-600 mb-2">
//                         New to ProtoHub?{" "}
//                         <Link to="/register" className="text-indigo-600 font-semibold hover:underline">
//                             Create account
//                         </Link>
//                     </p>
//                     <p className="text-center text-sm">
//                         <a href="#admin-login" className="text-gray-500 hover:text-indigo-600">
//                             Admin login →
//                         </a>
//                     </p>
//                 </div>
//             </div>
//         </div>
//     );
// }



import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layers, Mail, User, Building2, Shield, Eye, EyeOff, Briefcase, Phone } from "lucide-react";
import authService from "../service/authService";

export default function Login() {
    const navigate = useNavigate();
    const [rememberMe, setRememberMe] = useState(false);
    const [selectedRole, setSelectedRole] = useState("user");
    const [showPassword, setShowPassword] = useState(false);
    const [identifier, setIdentifier] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [inputType, setInputType] = useState("email"); // 'email' or 'phone'

    const roles = [
        { id: "user", label: "innovator", icon: User },
        { id: "expert", label: "Expert", icon: Briefcase },
        { id: "vendor", label: "Vendor", icon: Building2 },
        { id: "admin", label: "Admin", icon: Shield },
    ];

    // Auto-detect if input is email or phone
    const handleIdentifierChange = (e) => {
        const value = e.target.value;
        setIdentifier(value);

        // Detect if it's a phone number (starts with + or contains only digits and some special chars)
        if (value.startsWith('+') || /^[0-9+\-\s()]+$/.test(value)) {
            setInputType('phone');
        } else {
            setInputType('email');
        }
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setError("");
    //     setLoading(true);

    //     console.log('=== FORM SUBMITTED ===');
    //     console.log('Selected Role:', selectedRole);
    //     console.log('Identifier:', identifier);
    //     console.log('Password:', password ? '****' : 'empty');

    //     try {
    //         const response = await authService.login(identifier, password, selectedRole);
    //         console.log('Response from authService:', response);

    //         if (response.success) {
    //             console.log('Redirecting based on role:', selectedRole);

    //             // ✅ Updated redirect logic
    //             if (selectedRole === "user" || selectedRole === "Innovator") {
    //                 navigate("/app/dashboard");
    //             } else if (selectedRole === "expert") {
    //                 navigate("/app/expert-dashboard");
    //             } else if (selectedRole === "admin") {
    //                 navigate("/admin");
    //             } else if (selectedRole === "vendor") {
    //                 navigate("/vendor");  // ✅ Redirect to vendor dashboard
    //             } else {
    //                 // Fallback
    //                 navigate("/app/dashboard");
    //             }
    //         } else {
    //             console.log('Login failed:', response.message);
    //             setError(response.message || "Login failed. Please try again.");
    //         }
    //     } catch (err) {
    //         console.error('Error in handleSubmit:', err);
    //         setError(err.message || "Login failed. Please check your credentials and try again.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const handleSubmit = (e) => {
        e.preventDefault();

        console.log('=== FORM SUBMITTED ===');
        console.log('Selected Role:', selectedRole);

        // ✅ Just navigate directly without any API call
        if (selectedRole === "user") {
            navigate("/app/dashboard");
        } else if (selectedRole === "expert") {
            navigate("/experts");
        } else if (selectedRole === "admin") {
            navigate("/admin");
        } else if (selectedRole === "vendor") {
            navigate("/vendor");  // ✅ Test if vendor path works
        }
    };
    return (
        <div className="min-h-screen grid lg:grid-cols-2">
            {/* Left panel */}
            <div className="hidden lg:flex flex-col justify-between bg-gradient-to-br from-[#1e1b4b] via-[#4338ca] to-[#7c3aed] text-white p-12">
                <Link to="/" className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center">
                        <Layers className="text-white w-5 h-5" />
                    </div>
                    <div>
                        <p className="font-bold leading-tight">
                            APIC <span className="text-indigo-200">ProtoHub</span>
                        </p>
                        <p className="text-[11px] tracking-wide text-indigo-200 leading-tight">
                            ANDHRA PRADESH
                        </p>
                    </div>
                </Link>

                <div>
                    <h1 className="text-4xl font-extrabold leading-tight mb-4">
                        Discover. Design. <br /> Prototype. Innovate.
                    </h1>
                    <p className="text-indigo-100 max-w-sm">
                        A unified digital operating system for Andhra Pradesh's
                        Advanced Prototyping & Innovation Centres.
                    </p>
                </div>

                <p className="text-sm text-indigo-200">
                    © 2026 APIC ProtoHub · Government of Andhra Pradesh
                </p>
            </div>

            {/* Right panel */}
            <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
                <div className="rounded-xl border bg-card text-card-foreground shadow p-6 w-full max-w-md">
                    <h2 className="text-2xl font-extrabold text-gray-900 mb-1">
                        Welcome back
                    </h2>
                    <p className="text-gray-600 mb-8">
                        Sign in to your ProtoHub workspace.
                    </p>

                    {/* Error message */}
                    {error && (
                        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">
                            {error}
                        </div>
                    )}

                    {/* Role Selector - Subtle Toggle */}
                    <div className="bg-gray-50/80 rounded-xl p-1.5 mb-8 border border-gray-100/80 flex gap-1">
                        {roles.map((role) => {
                            const Icon = role.icon;
                            const isActive = selectedRole === role.id;
                            return (
                                <button
                                    key={role.id}
                                    type="button"
                                    onClick={() => setSelectedRole(role.id)}
                                    className={`
                                        flex-1 flex items-center justify-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200
                                        ${isActive
                                            ? "bg-white shadow-sm text-indigo-700 ring-1 ring-indigo-100"
                                            : "text-gray-500 hover:text-gray-700 hover:bg-white/50"
                                        }
                                    `}
                                >
                                    <Icon className={`w-4 h-4 ${isActive ? "text-indigo-600" : "text-gray-400"}`} />
                                    {role.label}
                                </button>
                            );
                        })}
                    </div>

                    <form className="space-y-5" onSubmit={handleSubmit}>
                        <label className="block">
                            <span className="block text-sm font-medium text-gray-700 mb-1.5">
                                Email or Phone Number
                            </span>
                            <div className="relative">
                                <input
                                    type="text"
                                    value={identifier}
                                    onChange={handleIdentifierChange}
                                    placeholder="Enter email or phone number"
                                    required
                                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent pl-10"
                                />
                                <div className="absolute left-3 top-1/2 -translate-y-1/2">
                                    {inputType === 'phone' ? (
                                        <Phone className="w-4 h-4 text-gray-400" />
                                    ) : (
                                        <Mail className="w-4 h-4 text-gray-400" />
                                    )}
                                </div>
                            </div>

                        </label>

                        <label className="block">
                            <span className="block text-sm font-medium text-gray-700 mb-1.5">Password</span>
                            <div className="relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                    className="w-full border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent pr-12"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                                >
                                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                </button>
                            </div>
                        </label>

                        <div className="flex items-center justify-between text-sm">
                            <label className="flex items-center gap-2 text-gray-600">
                                <input
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                    className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                />
                                Remember me
                            </label>
                            <a href="#forgot" className="text-indigo-600 font-medium hover:underline">
                                Forgot password?
                            </a>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-blue-600 hover:opacity-90 text-white font-semibold py-3 rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? (
                                <span className="flex items-center gap-2">
                                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Signing in...
                                </span>
                            ) : (
                                `Sign in as ${roles.find(role => role.id === selectedRole)?.label || selectedRole} →`
                            )}
                        </button>
                    </form>

                    <div className="flex items-center gap-4 my-6">
                        <div className="flex-1 h-px bg-gray-200" />
                        <span className="text-xs text-gray-400 font-medium">OR</span>
                        <div className="flex-1 h-px bg-gray-200" />
                    </div>

                    <p className="text-center text-sm text-gray-600 mb-2">
                        New to ProtoHub?{" "}
                        <Link to="/register" className="text-indigo-600 font-semibold hover:underline">
                            Create account
                        </Link>
                    </p>
                    {/* <p className="text-center text-sm">
                        <a href="#admin-login" className="text-gray-500 hover:text-indigo-600">
                            Admin login →
                        </a>
                    </p> */}
                </div>
            </div>
        </div>
    );
}